import { Point } from 'pixi.js';

export const COMPLETE_COLOR_COUNT = 13;
export const KING_VALUE = 13;
export const ACES_VALUE = 1;

// ======= dictionary =======
// Stockpile - whole deck on the left top corner
// Waste Pile - cards revealed next to the stockpile
// Foundation - place for Aces on the top
// Tableau - place with columns
// Column - one vertical group of cards in Tableau

export enum GamePlace {
    STOCKPILE = 'STOCKPILE', //on the stockpile on the left top - hidden,
    FOUNDATION = 'FOUNDATION', // on one of the aces, can have place value 0-3
    TABLEAU = 'TABLEAU', // in column can have place value 0-6
    WASTE_PILE = 'WASTE_PILE',
    FREECELL = 'FREECELL', // show on the top
}

export enum CardColors {
    DIAMONDS = '0',
    HEARTS = '1',
    CLUBS = '2',
    SPADES = '3',
}
export type CardPlace = {
    cardPlace: GamePlace; //
    value: number;
    position: Point;
    zIndex: number;
    order: number;
};
export type DropCardPlace = { place: GamePlace; dropColumnIndex: number };
